import { Actor, ActorSubclass, HttpAgent } from '@dfinity/agent';
import { Principal } from '@dfinity/principal';
import { IC_HOST, isLocalEnv } from './config';
import { IDL } from '@dfinity/candid';


export class AuthBase{

  private static agent: HttpAgent;  
  /**
   * create an actor with an anonymous identity
   * @param canisterDid
   * @param canisterId
   * @returns
   */
  public createActorWithAnonymousIdentity<T>(
    canisterId: string | Principal,
    canisterDid: IDL.InterfaceFactory
  ): ActorSubclass<T> {
    if (!AuthBase.agent) {
      AuthBase.agent = new HttpAgent({ host: IC_HOST });
      // The root key only has to be fetched for local development environments
      if (isLocalEnv()) {
        AuthBase.agent.fetchRootKey().catch(e => {
          console.error(`fetchRootKey error: ${e}`);
        });
      }
    }
    const actor = Actor.createActor<T>(canisterDid, {
      agent: AuthBase.agent,
      canisterId
    });

    return actor;
  }
}
